import React from 'react'
import Button from '@material-ui/core/Button'
import useStyles from './FileDropZone.style'
import CloudUploadRoundedIcon from '@material-ui/icons/CloudUploadRounded'
import PropTypes from 'prop-types'

export function FileDropZone(props) {
  const classes = useStyles()

  const onFileUploadpHandler = event => {
    event.preventDefault()
    event.stopPropagation()
    const [file] = event.dataTransfer
      ? event.dataTransfer.files
      : event.currentTarget.files
    const fileName = file.name
    const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
    if (event.currentTarget) {
      event.currentTarget.value = null
    }
    props.onDropSuccess({ file, fileName, fileType })
  }

  const onFiledragOverHandler = event => {
    event.preventDefault()
    event.stopPropagation()
  }

  const onFileUpload = () => {
    document.getElementById('coms-file-input').click()
  }

  const dropZoneClasses = props.errorOnFileDrop.errorOnDrop ? `${classes.dropzone} ${classes.dropzoneErrored}` : classes.dropzone
  const listSearchedClass = props.isListSearched ? `${dropZoneClasses} ${classes.dropZoneDisabled}` : `${dropZoneClasses}`

  return <div id="drop-area" data-testid="droparea" onDrop={event => onFileUploadpHandler(event)} onDragOver={event => onFiledragOverHandler(event)} className={listSearchedClass}>
      <div className={classes.uploadicon}>
        <CloudUploadRoundedIcon className={classes.uploadicon} />
      </div>
      <div>
        <span className={classes.dropzonetext}>Drag and drop or </span>
        <Button onClick={onFileUpload} data-testid="button-import-excel" variant="contained" color="primary" className={classes.btnStyle} size="large">
          <img className={classes.btnUpload} src="/images/btn_upload.svg" />
          Upload excel
        </Button>
        <input className={classes.fileinput} type="file" data-testid="file-input" id="coms-file-input" onChange={event => onFileUploadpHandler(event)} accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
      </div>
      <div className={classes.uploadNotes}>
        <span className={classes.uploadterms}>*</span>
        <span>
          Please note: OmniView Excel files for rent and sales comps may be missing data fields if the file is older than 13<sup>
            th
          </sup> Feb 2020 or has been altered after download
        </span>
      </div>
    </div>
}

FileDropZone.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  onDropSuccess: PropTypes.func,
  errorOnFileDrop: PropTypes.object,
  isListSearched: PropTypes.bool
}

export default FileDropZone
